import NotificationsCenter from '../components/Notifications/NotificationsPage';

const NotificationsPage = () => {
  return <NotificationsCenter />;
};

export default NotificationsPage;
